$(window).on("pageshow load", function() {
  $(".js-loading").fadeOut(1000);
  setTimeout(function() {
    $('.js-mainvisual__content').fadeIn(700);
  }, 1000);
  setTimeout(function() {
    $('.js-mainvisual__scroll').fadeIn(700);
  }, 1500);
})

$(document).ready(function() {
  setHeight();
  fadeEffect();
  $(window).scroll(function() {
      scroll = $(window).scrollTop();
      if(scroll > 0) {
        $('.js-mainvisual__scroll').fadeOut(500);
      }
      if(scroll === 0) {
          $('.js-mainvisual__scroll').fadeIn(500);
        }
    })	
    $('.js-profile__scroll').click(function (e) { 
        e.preventDefault();

        $('body, html').scrollTop(0);
      document.getElementById('exhibition').scrollIntoView({behavior: "smooth"});
     
    });
    $(document).on("scroll", onScroll);

    $('.js-shopdetail__close').on('click', function (e) {
        e.preventDefault();
       $('.c-shopdetail').removeClass('shop-show');
      $('.c-shopdetail').removeClass('event-show');

        $('.c-shopdetail').fadeOut(500);
    });
    $('.js-show-modal').on('click', function (e) {
        e.preventDefault();
          const content = $(this).find('.c-card2__modal').html();
          $('.c-shopdetail__content').empty();
 		 $('.c-shopdetail__content').html(content);
          $('.c-shopdetail').fadeIn(500);
    });
 

});

$(window).on('resize', function() {
  setHeight();
})


function onScroll(event){
  var scrollPos = $(document).scrollTop();
  $('.c-gnavi>ul>li').each(function (item,index) {
      
      var currLink = $(this);
      var refElement = $(currLink.find('a').attr("href")); // id



      if (scrollPos>refElement.offset().top - 100) {
          $('.c-gnavi>ul>li').removeClass("is-active");
          currLink.addClass("is-active");
         
      }
     
  });
  fadeEffect();
  
  
   if ($(window).scrollTop() >= $('#exhibition').offset().top) {
    	$('.u-gnavi-fade').addClass('u-gnavi-fade--show');
    }
  else{
    	$('.u-gnavi-fade').removeClass('u-gnavi-fade--show');
    }
}

function fadeEffect() {
  var scrollTop = $(window).scrollTop();
  var bottom = scrollTop + $(window).height();
  $('.u-fade').each(function() {
    if (bottom > $(this).offset().top + 200) {
      $(this).addClass('u-fade--show');
    }
  })
  
  
   
  
}

function setHeight() {
  var windowHeight = $(window).height();
  $('.js-mainvisual').outerHeight(windowHeight);
  $('.js-header').outerHeight(windowHeight);
  $('.js-loading').outerHeight(windowHeight);
}

